import { Instagram, MessageCircle, ArrowUp } from "lucide-react";
import { WHATSAPP_URL, INSTAGRAM_URL, EMAIL } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-slate-800 bg-slate-950 pt-20">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col justify-between gap-10 pb-16 md:flex-row md:items-start">
          <div>
            <p className="font-display text-2xl font-extrabold text-white">
              SOCIFY<span className="text-[#00F0FF]">.</span>
            </p>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate-400">
              Agencia de marketing digital. Estrategia, creatividad y resultados para negocios en España.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <p className="font-mono-sig text-[10px] uppercase tracking-[0.3em] text-slate-500">Contacto</p>
            <a data-testid="footer-whatsapp-link" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-slate-300 hover:text-[#25D366] transition-colors">
              <MessageCircle className="h-4 w-4" /> WhatsApp directo
            </a>
            <a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="text-sm text-slate-300 hover:text-white transition-colors">
              {EMAIL}
            </a>
            <a data-testid="footer-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-slate-300 hover:text-[#FF9F00] transition-colors">
              <Instagram className="h-4 w-4" /> @socify_marketing
            </a>
            <a data-testid="footer-blog-link" href="/blog" className="text-sm text-slate-300 hover:text-[#00F0FF] transition-colors">
              Blog de marketing
            </a>
          </div>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group flex h-12 w-12 items-center justify-center self-start rounded-full border border-slate-700 text-slate-400 transition-all hover:border-[#00F0FF] hover:text-[#00F0FF]"
          >
            <ArrowUp className="h-5 w-5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
        </div>
      </div>

      <div aria-hidden className="select-none overflow-hidden">
        <p className="text-outline-white whitespace-nowrap text-center font-display text-[18vw] font-extrabold leading-none tracking-tight">
          SOCIFY
        </p>
      </div>

      <div className="border-t border-slate-800/80">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-6 sm:flex-row">
          <p className="font-mono-sig text-[10px] uppercase tracking-[0.2em] text-slate-600">
            © 2026 Socify Marketing · España
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 font-mono-sig text-[10px] uppercase tracking-[0.2em] text-slate-600">
            <a data-testid="footer-link-aviso-legal" href="/aviso-legal" className="transition-colors hover:text-[#00F0FF]">Aviso legal</a>
            <a data-testid="footer-link-privacidad" href="/privacidad" className="transition-colors hover:text-[#00F0FF]">Privacidad</a>
            <a data-testid="footer-link-cookies" href="/cookies" className="transition-colors hover:text-[#00F0FF]">Cookies</a>
            <a data-testid="footer-link-admin" href="/admin" className="transition-colors hover:text-[#00F0FF]">Panel</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
